import {
  CacheEntities,
  fetchWithCache,
  generateCacheKey,
} from "@punchup/utils/caches";

import createNoAuthSupabaseClient from "../../supabase/supabase";

const PAGE_GROUP_MEMBERS_TTL = 300;

export async function getPageGroupMemberIds(pageId: string): Promise<string[]> {
  const supabase = createNoAuthSupabaseClient();
  const { data, error } = await supabase
    .from("page_group_members")
    .select("member_page_id")
    .eq("group_page_id", pageId);

  if (error) throw error;

  return data?.map((row) => row.member_page_id) ?? [];
}

export function getPageGroupMemberIdsWithCache(
  pageId: string
): Promise<string[]> {
  const key = generateCacheKey(CacheEntities.PAGE_GROUP_MEMBERS, pageId);
  return fetchWithCache(
    key,
    () => getPageGroupMemberIds(pageId),
    PAGE_GROUP_MEMBERS_TTL
  );
}
